var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"text-white align-middle text-center font-bold"},[_c('span',[_vm._v("Innehar F-skattesedel")])])}]

export { render, staticRenderFns }